import { Box, Button, Flex, GridItem, Heading, HStack, Icon, Image, SimpleGrid, Span, Strong, Text } from '@chakra-ui/react'
import React, { use } from 'react'
import { motion } from 'framer-motion';
import { useColorModeValue } from '../../../components/ui/color-mode'
import { LuArrowRight, LuFingerprint, LuMousePointer2 } from 'react-icons/lu'
import { useTranslation } from 'react-i18next';
// import { HashLink } from 'react-router-hash-link';
import { useNavigate } from 'react-router-dom';

const MotionBox = motion.create(Box);
const MotionText = motion.create(Text);
const MotionHeading = motion.create(Heading);
const MotionHStack = motion.create(HStack);
const MotionButton = motion.create(Button);
let isIOSDevice = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent); // fails on iPad iOS 13


const WhyUs = () => {

  const {t} = useTranslation()
  const navigate = useNavigate()

  return (
    <Flex
      px={{ md: '10%', '2xl': "19%", base: 4 }}
      position={'relative'}
      py={20}
      overflow={'hidden'}
      justifyContent={'center'}
    >
      <SimpleGrid placeItems={{'2xl': 'inherit', base: 'center'}} columns={{ '2xl': 2, md: 2, base: 1}} gap={10}>
        <GridItem display={'flex'} alignItems={'center'} >

          <Box position={'relative'}>

            <Box zIndex={2} left={{ '2xl': -48, md: '-14em', base: -4 }} top={{ md: 20, base: 'inherit' }} bottom={{ md: 'unset', base: 16 }} position={'absolute'} display={'flex'} justifyContent={{ md: 'end', base: 'left' }} alignItems={{ md: 'end', base: 'start' }} flexDir={'column'} gap={1}>
              <MotionHStack
                boxShadow={'sm'}
                w={'max-content'}
                p={2} px={3}
                rounded={'full'}
                bgColor={'white'}
                initial={{ scale: 0.8 }}
                whileInView={{ scale: [1, 1.1, 1] }}
                transition={{ duration: 0.8, times: [0, 0.5, 1], repeat: 1, repeatDelay: 3 }}
                viewport={{ once: false }}
              >
                <Flex color={useColorModeValue('white', 'gray.800')} justifyContent={'center'} align={'center'} rounded={4} p={1} bgColor={'orange.500'}>
                  <Icon>
                    <LuMousePointer2 />
                  </Icon>
                </Flex>
                <Text color={'gray.800'} fontFamily={'Inter'} fontWeight={'medium'} fontSize={'sm'}>{t('vectorAssetText2')}</Text>
              </MotionHStack>

              <HStack boxShadow={'sm'} p={2} px={3} rounded={'full'} bgColor={'white'} position={'relative'}>
                <Flex color={useColorModeValue('white', 'gray.800')} justifyContent={'center'} align={'center'} rounded={4} p={1} bgColor={'blue.500'}>
                  <Icon>
                    <LuFingerprint />
                  </Icon>
                </Flex>
                <Box>
                  <Text color={'gray.800'} fontFamily={'Inter'} fontWeight={'medium'} fontSize={'sm'}>{t('vectorAssetText3')}</Text>
                </Box>
              </HStack>
            </Box>
            <MotionBox
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                animate={{
                  y: [0, -15, 0],
                  rotate: [0, 1.5, -1.5, 0],
                  scale: [1, 1.02, 1]
                }}
                transition={{
                  y: { duration: 6, repeat: Infinity, ease: "easeInOut" },
                  rotate: { duration: 7, repeat: Infinity, ease: "easeInOut" },
                  scale: { duration: 8, repeat: Infinity, ease: "easeInOut" },
                  default: { duration: 0.8 }
                }}
                viewport={{ once: true }}
              _before={{
                content: "''",
                w: 'full',
                h: 'full',
                zIndex: 10,
                position: 'absolute',
                bottom: -1,
                left: 0,
                bgGradient: 'to-t',
                gradientFrom: useColorModeValue('white 1%', 'black'),
                gradientTo: 'transparent 20%'
              }}
            >

              <Image
                position={'relative'}
                w={{ '2xl' : '400px', base: '280px'}}
                src={require('../../../assets/vector/3.png')}
              />
            </MotionBox>

            {/* box glass top */}
            <Box
              zIndex={2}
              boxSize={40}
              display={{ md: 'block', base: 'none' }}
              rounded={24}
              position={'absolute'}
              top={8}
              right={-28}
              p={5}                          // Espacement intérieur
              bg="rgba(255, 255, 255, 0.15)" // Couleur de fond blanche avec transparence (entre 0.1 et 0.3 fonctionne bien)
              backdropFilter="blur(10px)"    // L'effet de flou sur l'arrière-plan de cet élément
              boxShadow="0 4px 30px rgba(0, 0, 0, 0.1)" // Une ombre subtile pour un effet 3D
            // Une bordure semi-transparente pour simuler le bord du verre                 // Couleur du texte
            >
              <Text fontSize="sm" opacity={0.8}>online voting</Text>
              <Text fontSize="3xl" fontWeight="bold" fontFamily={'Onest'}>100%</Text>
              <Box>
                <MotionText fontSize="md" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.2 }}>Fast</MotionText>
                <HStack spacing={1}>
                  <MotionText fontSize="sm" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.4 }}>Secure</MotionText>
                  <Text fontSize="sm">and</Text>
                  <MotionText fontSize="sm" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.6 }}>easy</MotionText>
                </HStack>
              </Box>
            </Box>
          </Box>


        </GridItem>

        <GridItem>
          <Box>
            <MotionHeading mt={4} 
              fontFamily={'Poppins'} 
              fontSize={{ '2xl': '7xl', md: '3xl', base: '2xl' }}
              fontWeight={600}
              lineHeight={1.1}
              letterSpacing={-1.8}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              {t('whyChooseUsTitle')} 
              <Span
                pl={2}
                bgGradient={'to-r'}
                gradientFrom={'blue.500'}
                gradientTo={'purple.600'}
                bgClip={'text'}
              > escrutin ?</Span>
            </MotionHeading>


            <Text mt={{'2xl' :20, base: 4}}fontSize={{ '2xl': 'xl', base: 'md'}} lineHeight="tall">
              {t('whyChooseUsDescription')}
            </Text>

            <Box mt={10}>
              <Flex float={'left'} mr={4} justify={'center'} align={'center'} w={'min-content'}>
                <Box className='squircle' w={{ '2xl': '50px', base: '40px'}} rotate={'45deg'} bgGradient={'to-bl'}
                  gradientFrom={useColorModeValue('blue.200', 'blue.800')}
                  gradientTo={useColorModeValue('purple.200', 'purple.700')} />
                <Span position={'absolute'} fontFamily={'Outfit'} fontSize={{'2xl': '2xl', base: 'md'}} fontWeight={600}>01</Span>
              </Flex>

              <Text fontSize={{'2xl': 'lg', base: 'md'}}>
              {t('listItem1')}
              <Strong> Orange, MTN, Airtel, Moov</Strong>.</Text>
            </Box>
            <Box mt={{'2xl' :10, base: 4}}>
              <Flex float={'left'} mr={4} justify={'center'} align={'center'} w={'min-content'}>
                <Box className='squircle' w={{ '2xl':'50px', base: '40px'}} rotate={'45deg'} bgGradient={'to-bl'}
                  gradientFrom={useColorModeValue('blue.200', 'blue.800')}
                  gradientTo={useColorModeValue('purple.200', 'purple.700')} />
                <Span position={'absolute'} fontFamily={'Outfit'} fontSize={{'2xl': '2xl', base: 'md'}} fontWeight={600}>02</Span>
              </Flex>

              <Text fontSize={{'2xl': 'lg', base: 'md'}}>
                {t('listItem2')}
              </Text>
            </Box>

            <Flex mt={8} justify={'end'}>
              
                  <MotionButton
                    fontFamily={'Momo Trust Display'}
                    fontWeight={ isIOSDevice ? 'medium' : 'normal'}
                    size={{ '2xl': 'lg', base: 'md'}}
                    rounded={'full'}
                  colorPalette={'purple'}
                  variant={'ghost'}
                  whileHover={{ scale: 1.05 }}
                  onClick={() => navigate('/services/voting/#geographic-coverage')}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  {t('callToActionFeature')}
                  <MotionBox
                    ml={2}
                    animate={{ x: [0, 5, 0] }}
                    transition={{ duration: 1, repeat: Infinity, ease: "easeInOut" }}
                  >
                    <Icon>
                      <LuArrowRight />
                    </Icon>
                  </MotionBox>
                </MotionButton>
            </Flex>
          </Box>
        </GridItem>
      </SimpleGrid>



      <Box w={{ '2xl': '800px', base: '450px'}} rotate={'50deg'} opacity={0.5} top={0} position={'absolute'} left={{md: '8%', base: 'inherit'}} zIndex={-1} filter={'blur(10px)'}>
        <svg viewBox="0 0 1047 1048" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M385.103 346.022C418.294 382.337 463.353 405.617 512.177 411.675C561 417.733 610.383 406.172 651.443 379.07C692.503 351.969 722.545 311.106 736.166 263.831C749.788 216.557 746.094 165.973 725.749 121.179C705.404 76.3853 669.744 40.3203 625.183 19.4714C580.621 -1.37744 530.082 -5.64197 482.657 7.4449C435.232 20.5318 394.033 50.1112 366.469 90.8627C338.906 131.614 326.788 180.864 332.295 229.752L537.62 206.624L385.103 346.022Z" fill="url(#paint0_linear_0_1)" />
          <path d="M359.141 371.728C392.332 408.043 411.476 455.009 413.13 504.179C414.784 553.349 398.839 601.496 368.164 639.959C337.488 678.422 294.095 704.678 245.789 714.004C197.483 723.329 147.435 715.112 104.647 690.831C61.8583 666.55 29.1378 627.798 12.3705 581.546C-4.3968 535.294 -4.11042 484.576 13.1781 438.516C30.4666 392.456 63.6227 354.077 106.683 330.28C149.742 306.484 199.88 298.833 248.078 308.703L206.624 511.126L359.141 371.728Z" fill="url(#paint1_linear_0_1)" />
          <path d="M660.595 701.554C627.404 665.239 582.344 641.958 533.521 635.9C484.697 629.842 435.315 641.403 394.255 668.505C353.195 695.606 323.152 736.469 309.531 783.744C295.91 831.018 299.603 881.602 319.948 926.396C340.293 971.19 375.953 1007.25 420.515 1028.1C465.076 1048.95 515.615 1053.22 563.04 1040.13C610.465 1027.04 651.665 997.464 679.228 956.712C706.791 915.961 718.909 866.712 713.402 817.823L508.077 840.951L660.595 701.554Z" fill="url(#paint2_linear_0_1)" />
          <path d="M687.541 676.925C654.35 640.61 635.206 593.644 633.552 544.474C631.898 495.304 647.843 447.157 678.519 408.694C709.194 370.231 752.587 343.975 800.893 334.65C849.199 325.324 899.247 333.541 942.036 357.822C984.824 382.103 1017.54 420.855 1034.31 467.107C1051.08 513.359 1050.79 564.077 1033.5 610.137C1016.22 656.197 983.06 694.577 940 718.373C896.94 742.169 846.802 749.82 798.605 739.95L840.059 537.527L687.541 676.925Z" fill="url(#paint3_linear_0_1)" />
          <defs>
            <linearGradient id="paint0_linear_0_1" x1="398.223" y1="54.1065" x2="677.018" y2="359.142" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3B72EA" />
              <stop offset="1" stopColor="#c824bbff" />
            </linearGradient>
            <linearGradient id="paint1_linear_0_1" x1="67.226" y1="358.608" x2="346.021" y2="663.643" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3B72EA" />
              <stop offset="1" stopColor="#c824bbff" />
            </linearGradient>
            <linearGradient id="paint2_linear_0_1" x1="647.475" y1="993.469" x2="368.679" y2="688.434" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3B72EA" />
              <stop offset="1" stopColor="#c824bbff" />
            </linearGradient>
            <linearGradient id="paint3_linear_0_1" x1="979.456" y1="690.045" x2="700.661" y2="385.01" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3B72EA" />
              <stop offset="1" stopColor="#c824bbff" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    </Flex>
  )
}

export default WhyUs